import { Text } from '@dixa/lib-shared-habla';

import styles from './Title.module.scss';

type TitleProps = {
  title: string;
};
export function Title({ title }: TitleProps): JSX.Element {
  return (
    <Text.Heading
      className={styles.title}
      color="secondary"
      variant="heading-3"
    >
      {title}
    </Text.Heading>
  );
}
